import React, { useState, useEffect } from 'react';

import * as Constants from '../../../../helpers/constants';
import { LIST_STATUSES } from '../../helpers/constants';
import * as Helpers from '../../../../helpers/helper';

import 'react-circular-progressbar/dist/styles.css';
import RadarProgress from './radar_progress';

const CircularProgress = ({
  listDetails,
  service
}) => {
  const [details, setDetails] = useState(listDetails);

  useEffect(() => {
    setDetails(listDetails);
  }, [listDetails]);

  const getProgressAndAction = () => {
    if (service.NAME === 'prospect') {
      return {
        progress: details.enrich_progress || { progress: 0 },
        actionInProgress: details.enrich_action_inprogress || { action: '' },
      };
    }
    return {
      progress: details.progress || { progress: 0 },
      actionInProgress: details.action_inprogress || { action: '' },
    };
  };

  const showVerifyOrCancel = () => {
    const { actionInProgress } = getProgressAndAction();

    if (details.status === LIST_STATUSES.CANCELLED) {
      return (
        <div className='progress-info-div'>
          <p className='w-auto mt-2 mx-auto'>
            <span>Cancelling...</span>
          </p>
        </div>
      );
    } else {
      const actionStatus = Constants.LIST_ACTIONS[actionInProgress.action]?.progress || 'Processing...';
      return (
        <p className='w-auto mt-2 mx-auto'>
          <span>{actionStatus}</span>
        </p>
      );
    }
  };

  const { progress } = getProgressAndAction();

  // Try to render the new Deep Verification Orbit chart first
  let orbitModel = Helpers.getOrbitModel(progress);

  if (orbitModel) {
    let isCancelling = details.status === LIST_STATUSES.CANCELLED;
    let dv = progress && progress.deep_verify;

    let radarModel = {
      fileName: details.list_name || details.details?.name,
      stageLabel: orbitModel.stageLabel,
      mode: Helpers.ORBIT_MODE_LABELS?.[details.mode] || details.mode,
      percent: parseInt(orbitModel.centerPrimary, 10) || 0,
      centerPrimary: parseInt(orbitModel.centerPrimary, 10) || 0,
      centerSecondary: isCancelling ? 'cancelling…' : orbitModel.centerSecondary,
      etaLabel: dv ? Helpers.getTimeRemainingLabel(dv.eta || dv.wait_until) : null,
      live: !isCancelling,
      legend: orbitModel.legend,
      totalForRing: orbitModel.total,
    };

    return (
      <div className='progress-info-div'>
        <div className='file-upload-progress'>
          <RadarProgress model={radarModel} />
        </div>
      </div>
    );
  }

  // Fallback to standard standard basic circle progress 
  const progressVal = progress.progress || 0;

  // Create a basic radar model for when we don't have deep verify data
  let fallbackRadarModel = {
    fileName: details.list_name || details.details?.name,
    percent: progressVal,
    centerPrimary: progressVal.toFixed(2),
    centerSecondary: (details.status === LIST_STATUSES.CANCELLED) ? 'cancelling…' : 'Verifying',
    canShowBreakdown: false // This tells the radar to render a single progress ring without slices
  };

  return (
    <div className='progress-info-div'>
      <div className='file-upload-progress'>
        {/* Replace the old CircularProgressbar with our new RadarProgress */}
        <RadarProgress model={fallbackRadarModel} />
        {showVerifyOrCancel()}
      </div>
    </div>
  );
};

export default CircularProgress;
